import request from "../utils/request";
import store from "../store"
import { APP_API_BASE_URL } from "../utils/env"

const manageApi = {
    Organization: "/institution/",
    Dept: "/institution/dept",
    Team: "/team/",
    Disease: "/base/disease/",
    TeamDoctor: "/team/doctor",
    TeamDoctorUser: "/team/doctor/user",
    AddressBook: "user/list?last_update_time=",
    UserDept: APP_API_BASE_URL + "user/dept",
    Apply: "/apply/",
    BaseDisease: "/disease/base",
    TeamPackage: "/service_package",
    CreatGroup: "/apply/create_group",
    ApplySilence: '/apply/silence'
}

export function getOrganizationListApi(parameter) {
    return request({
        url: manageApi.Organization,
        method: "get",
        params: parameter
    })
}
export function updateOrganizationApi(parameter) {
    return request({
        url: manageApi.Organization,
        method: "post",
        data: parameter
    })
}
export function deleteOrganizationApi(id) {
    return request({
        url: manageApi.Organization + id,
        method: "delete",
    });
}
export function getDeptListApi(parameter) {
    return request({
        url: manageApi.Dept,
        method: "get",
        params: parameter,
    })
}
export function updateDeptApi(parameter) {
    return request({
        url: manageApi.Dept,
        method: "post",
        data: parameter,
    })
}

export function deleteDeptApi(id) {
    return request({
        url: manageApi.Dept + '/' + id,
        method: "delete",
    })
}

export function getTeamListApi(parameter) {
    return request({
        url: manageApi.Team,
        method: "get",
        params: parameter
    });
}

export function addTeamApi(parameter) {
    return request({
        url: manageApi.Team,
        method: "post",
        data: parameter,
    })
}

export function updateTeamApi(parameter) {
    return request({
        url: manageApi.Team,
        method: "patch",
        data: parameter,
    })
}

export function deleteTeamApi(id) {
    return request({
        url: manageApi.Team + id,
        method: "delete"
    })
}
export function getDiseaseBaseListApi() {
    return request({
        url: manageApi.BaseDisease,
        method: 'get'
    })
}
export function getDiseaseListApi(parameter) {
    return request({
        url: manageApi.Disease,
        method: "get",
        params: parameter,
    })
}
export function addDiseaseApi(parameter) {
    return request({
        url: manageApi.Disease,
        method: "post",
        data: parameter,
    })
}
export function getDiseaseDetailApi(id) {
    return request({
        url: manageApi.Disease + id,
        method: "get"
    })
}
export function updateDiseaseApi(parameter) {
    return request({
        url: manageApi.Disease,
        method: "patch",
        data: parameter,
    })
}
export function deleteDiseaseApi(id) {
    return request({
        url: manageApi.Disease + id,
        method: "delete",
    })
}

export function getTeamDoctorListApi(config) {
    return request({
        url: manageApi.TeamDoctor,
        method: "get",
        params: config.params,
        headers: config.headers,
        withoutHeaders: true
    })
}
export function addTeamDoctorApi(data) {
    return request({
        url: manageApi.TeamDoctor,
        method: "post",
        data
    })
}

export function updateTeamDoctorApi(data) {
    return request({
        url: manageApi.TeamDoctor,
        method: "put",
        data
    })
}
export function removeTeamDoctorApi(data) {
    return request({
        url: manageApi.TeamDoctor,
        method: "delete",
        data
    })
}
export function getUserDeptListApi() {
    return request({
        url: manageApi.UserDept,
        method: "get",
        withoutHeaders: true,
        headers: {
            tenant: store.state.tenant.tenant
        }
    })
}

export function addTeamDoctorUserApi(data) {
    return request({
        url: manageApi.TeamDoctorUser,
        method: "post",
        data
    })
}

export function getPatientApplyApi(parameter) {
    return request({
        url: manageApi.Apply,
        method: "get",
        params: parameter
    })
}
export function getTeamPackageApi(parameter) {
    return request({
        url: manageApi.TeamPackage,
        method: "get",
        params: parameter
    })
}
export function addTeamPackageApi(data) {
    return request({
        url: manageApi.TeamPackage,
        method: "post",
        data
    })
}
export function updateTeamPackageApi(data) {
    return request({
        url: manageApi.TeamPackage,
        method: "put",
        data
    })
}
export function deleteTeamPackageApi(id) {
    return request({
        url: manageApi.TeamPackage + '/' + id,
        method: "delete",
    })
}
export function updateCreateGroupApi(parameter) {
    return request({
        url: manageApi.CreatGroup,
        method: "post",
        params: parameter
    })
}

export function applySilenceApi(parameter) {
    return request({
        url: manageApi.ApplySilence,
        method: "put",
        params: parameter
    })
}

export function cancelApplySilenceApi(parameter) {
    return request({
        url: manageApi.ApplySilence,
        method: "delete",
        params: parameter
    })
}